<template>
  <div @click="doClick" class="info-banner">
    <div class="info-title-wrapper">
      <slot name="left-content"></slot>
      <p v-html="text"></p>
    </div>
    <slot name="right-content"></slot>
  </div>
</template>

<script>
export default {
  name: 'InfoBanner',
  props: ['text', 'callback', 'href', 'confirmText', 'confirmTitle'],
  data() {
    return {
      clicked: false,
    };
  },
  methods: {
    doClick() {
      if (this.confirmText) {
        this.$confirm(
          this.$t('global.word.pay_attention'),
          this.confirmText,
          'alert',
          null,
          true
        ).then((result) => {
          this.clickEvent(result);
        });
      } else {
        this.clickEvent();
      }
    },
    clickEvent(confirmed) {
      // Timeout because @click on root element blocks changing this.clicked.
      setTimeout(() => {
        this.clicked = false;
      }, 10);

      if (confirmed !== 'yes') {
        return;
      }

      if (this.href) {
        window.location.href = this.href;
      } else if (this.callback) {
        this.callback();
      }
    },
  },
  mounted() {},
};
</script>
